export default "/images/vendor/flag-icon-css/flags/1x1/gt.svg?224b126cfd53d82199717cc3dc163c65";